export const version = 'v2.2.4-1985-gd137e7c9b'
